import { createAction, props } from '@ngrx/store';
import { createRegisterActions } from 'src/app/common-components/register/models/register-actions';
import { PhoneNumbersFilterOption } from '../models/phone-number-filter-option';
import { PhoneNumberRegisterListItem } from '../models/phone-number-register-results.model';

const area = 'PhoneNumber Register';
export const phoneNumberRegisterAdapterActions = createRegisterActions<PhoneNumberRegisterListItem>(area);

export const createPhoneNumber = createAction(`[${area}] Create PhoneNumber`);

export const phoneNumberRegisterInitialFilter = createAction(
   `[${area}] Initial Filter`,
   props<{ filters: PhoneNumbersFilterOption[] }>()
);

export const loadSystemPhoneNumbersSuccess = createAction(`[System ${area}] Register Load Success`);

export const loadAccountPhoneNumbersSuccess = createAction(`[Account ${area}] Register Load Success`);
